import { addMinutes } from "date-fns";
import { asDate } from "../date-time/as-date";
import { convertTimeByGranularity } from "../date-time/time-granularity";
import type { TimeRange} from "../date-time/time-range";
import { timeRangeFactory } from "../date-time/time-range";
import type { DurationInMinutes } from "../date-time/time-spans";
import type { BookableSession } from "./sessions/bookable-session";

const minSessionDurationInMinutes = (
    session: BookableSession,
): DurationInMinutes => {
    return convertTimeByGranularity(
        session.durationMinMax.min,
        session.durationGranularity,
        "MINUTE",
    );
};

const minSessionTimeRange = (session: BookableSession): TimeRange => {
    const starts = asDate(session.start);
    const duration = minSessionDurationInMinutes(session);
    const ends = addMinutes(starts, duration);
    return timeRangeFactory(starts, ends);
};

export { minSessionDurationInMinutes, minSessionTimeRange };
